import _ from "lodash";
import * as Yup from "yup";
import { useState } from "react";
import { useFormik } from "formik";
import { FormInput } from "../../common/form-controllers/FormInput";
import { FormDropdown } from "../../common/form-controllers/FormDropdown";
import { PROGRAM_TYPE } from "../../../consts/methods.consts";
import { ToastService } from "../../../services/toast.service";
import { useSearchParams } from "react-router-dom";
import { DROPDOWN_TAGS, PROGRAM_TYPE_TAGS } from "../../../consts/tags.consts";
import { PageHeaderActions } from "../../common/page-header/PageHeader";
import { useTableDataProvider } from "../../hooks";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { ChakraModal, PageHeader } from "../../index";
import { useGetQuery, usePostMutation } from "../../../services/api.service";
import ChakraTable, { ChakraTableColumns } from "../../common/chakra-table/ChakraTable";
import { customeJsonParser } from "../../../utils/utils";

const ProgramTypeListPage = () => {

    const disclosure = useDisclosure()
    const [page, setPage] = useState(1)
    const toast = new ToastService(useToast())
    const [isSelected, setIsSelected] = useState<boolean>(false);
    const [create] = usePostMutation();

    const { data, isLoading, isFetching } = useGetQuery({
        method: PROGRAM_TYPE.LIST,
        body: {
            page: page,
        },
        providesTags: [PROGRAM_TYPE_TAGS.LIST]
    })

    const { data: initialData } = useGetQuery({
        method: PROGRAM_TYPE.INIT,
        providesTags: [PROGRAM_TYPE_TAGS.INIT, DROPDOWN_TAGS.LIST]
    })

    const category_list = _.get(initialData, ['message'], [])

    const { dataList, paginationDetails } = useTableDataProvider(data);

    const formik = useFormik({
        initialValues: {
            title: ''
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Name is required"),
            program_category: Yup.string().required("Program Category is required"),
        }),
        onSubmit: async (values) => {
            try {
                await create({
                    method: isSelected ? PROGRAM_TYPE.UPDATE : PROGRAM_TYPE.ADD,
                    body: values,
                    invalidatesTags: [PROGRAM_TYPE_TAGS.LIST, DROPDOWN_TAGS.LIST]
                }).unwrap();

                toast.setTitle("Success").setDescription(`${isSelected ? "Program type details have been saved" : "Program type has been created successfully"}`).showSuccessToast();

            } catch (error: any) {
                let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
                if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();
            } finally {
                disclosure.onClose();
                setIsSelected(false);
            }
        }
    })

    const ondeleteHandler = async (item: any) => {
        try {
            const res = await create({
                method: PROGRAM_TYPE.DELETE,
                body: { id: item?.name },
                invalidatesTags: [PROGRAM_TYPE_TAGS.LIST, DROPDOWN_TAGS.LIST]
            }).unwrap();

            toast.setTitle("Success").setDescription("Program type is deleted successfully.").showSuccessToast();

        } catch (error: any) {
            let message = customeJsonParser(_.get(error?.data, '_server_messages', {}))
            if (message) toast.setTitle("Error").setDescription(customeJsonParser(message)?.message).showErrorToast();
        }

    }

    const PROGRAM_TYPE_COLUMNS: ChakraTableColumns = [
        {
            header: "Name",
            accessor:
                "title",
        },
        {
            header: "Program Category",
            accessor:
                "program_category_title",
        },
        {
            header: "Actions",
            accessor: '',
            disabled: false,
            width: 100,
            options: [
                {
                    label: "Edit",
                    confirmation: false,
                    onClick(item) {
                        formik.setFieldValue("title", _.get(item, "title"))
                        formik.setFieldValue("name", _.get(item, "name"))
                        formik.setFieldValue("program_category", _.get(item, "program_category"))
                        setIsSelected(true)
                        disclosure.onOpen()
                    },
                },
                {
                    label: "Delete",
                    onClick: ondeleteHandler,
                }
            ]
        }
    ]


    const actions: PageHeaderActions = [

        {
            text: "Create New",
            confirmation: false,
            onClick: () => {
                setIsSelected(false)
                formik.resetForm();
                disclosure.onOpen()
            },
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]

    const onPage = (page: any) => {
        setPage(page)
    }


    return (
        <>
            <div>
                <PageHeader subtitle="View and Manage Program Types" title={`Programs Type`} actions={actions} />
                <ChakraTable onPage={onPage} isFetching={isFetching} paginationDetails={paginationDetails} isLoading={isLoading} pagination size={"sm"} header
                    title="Program Types"
                    columns={PROGRAM_TYPE_COLUMNS} data={dataList} />
                <ChakraModal primaryAction={formik.submitForm} primaryButtonText={"Save"} modalTitle={`${isSelected ? 'Edit Program Type' : 'New Program Type'}`} {...disclosure}>
                    <FormInput isRequired formik={formik} name="title" autoFocus label="Name" />
                    <FormDropdown isRequired options={category_list}
                        label="Program Category" formik={formik}
                        name="program_category" />
                </ChakraModal>
            </div>
        </>
    )
}

export default ProgramTypeListPage